import {
  makeStyles,
  shorthands,
  tokens,
} from '@fluentui/react-components';

export const useStyles = makeStyles({
  adsStudioColorPicker: {
    '& .color_icon': {
      width: '20px',
      height: '20px',
    },

    '& .info_icon': {
      width: '14px',
      height: '14px',
    },
    '& .card-header': {
      ...shorthands.borderBottom(tokens.strokeWidthThin, 'solid', tokens.colorNeutralStroke2),
    },
    '& .list-body-header': {
      ...shorthands.margin('12px', 0),
    },
  },
  flex: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  editBtn: {
    width: '32px',
    height: '32px',
    ...shorthands.borderRadius(tokens.borderRadiusCircular),
    backgroundColor: tokens.colorNeutralBackground1,
    backdropFilter: 'blur(4px)',
  },
  delBtn: {
    ...shorthands.border('none'),
    width: '100%',
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorNeutralForeground2,
    ...shorthands.padding(tokens.spacingVerticalM),
    '&:hover': {
      backgroundColor: tokens.colorNeutralBackground1,
    },
  },
  flexColumn: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  hr: {
    position: 'absolute',
    left: 0,
    right: 0,
    ...shorthands.margin(0),
    color: tokens.colorNeutralStroke1,
  },
  tooltip: {
    width: '300px',
    maxWidth: '300px',
    flexDirection: 'column',
  },
  adsStudioColorPalette: {
    display: 'flex',
  },
  paletteAddColor: {
    ...shorthands.borderRadius(tokens.borderRadiusXLarge),
    maxWidth: 'none',
  },
  paletteColor: {
    ...shorthands.borderRadius(tokens.borderRadiusXLarge),
    maxWidth: 'none',
  },
  paletteBox: {
    ...shorthands.border(tokens.strokeWidthThick, 'solid', tokens.colorNeutralBackground1),
    ...shorthands.borderRadius(tokens.borderRadiusXLarge),
  },
  newColor: {
    ...shorthands.border(tokens.strokeWidthThin, 'dashed', '#C8C6C4'),
  },
});

export const colorPickerStyles = {
  panel: { padding: 12 },
  root: {
    minWidth: 276,
  },
  flexPreviewBox: {
    styles: {
      ...shorthands.margin(0, 0, '10px', 0),
      '&>div': { height: '24px', width: '24px', ...shorthands.borderRadius(tokens.borderRadiusCircular) },
    },
  },
  flexContainer: {
    alignItems: 'center',
  },
  flexSlider: {
    styles: {
      ...shorthands.margin(tokens.spacingHorizontalSNudge, 0),
      '&>div': { height: '8px', ...shorthands.borderRadius(tokens.borderRadiusMedium) },
      '&>div>div': { width: '12px', height: '12px' },
    },
  },
  colorRectangle: { minHeight: 130 },
};


export const getSkeletonStyles = makeStyles({
  row: {
    display: 'flex',
    ...shorthands.gap('8px'),
    flexWrap: 'wrap',
  },
  item: {
    height: '55px',
    width: '55px',
    backgroundColor: tokens.colorNeutralStencil1,
  },
});
